import { jsx as i } from "react/jsx-runtime";
import { useRef as l } from "react";
import "styled-components";
import { useThemeInMode as m } from "../../../../context/theme/hooks.js";
import "../../../layout/Stack/Stack.js";
import p from "../../../layout/Box/Box.js";
import "../../../../index-CZ8zjHGv.js";
import "../../../layout/Center/Center.js";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../../layout/Columns/ColumnsContext.js";
function S({
  searchValue: t,
  autoFocus: e,
  onChangeSearch: n
}) {
  const o = m(), r = l(null);
  return /* @__PURE__ */ i(
    p,
    {
      ref: r,
      autoFocus: e,
      onClick: () => {
        r.current.focus();
      },
      component: "input",
      placeholder: "Search...",
      onChange: n,
      value: t,
      width: "100%",
      height: "38px",
      paddingX: "12",
      paddingY: "12",
      backgroundColor: o.foreground,
      color: o["neutral-high-content"],
      placeholderStyles: { color: o["neutral-medium-content"] },
      borderTopLeftRadius: "small",
      borderTopRightRadius: "small",
      borderWidth: "none",
      borderBottomWidth: "xxxsmall",
      borderColor: o["neutral-high-content"],
      focusStyles: {
        outline: "0"
      }
    }
  );
}
export {
  S as default
};
